import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles<Theme, { isCouponEditable: boolean }>(
  theme => ({
    cardContainer: {
      marginTop: 16
    },
    cardTitle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "8px 24px",
      paddingBottom: "8px !important"
    },
    cardContentContainer: {
      padding: "0",
      paddingBottom: "8px !important"
    },
    cardTitleContentContainer: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      padding: "8px 24px",
      paddingBottom: "8px !important"
    },
    exportAllButton: {
      "& span": {
        color: "#ffffff"
      },
      "&:hover": {
        backgroundColor: "#3c60fa"
      },
      border: "1px solid #0030FF",
      backgroundColor: "#0030FF",
      borderRadius: "8px 0 0 8px"
    },
    setCodesButton: {
      "& span": {
        color: ({ isCouponEditable }) =>
          isCouponEditable ? "#0030FF" : "#00000042"
      },
      border: ({ isCouponEditable }) =>
        isCouponEditable ? "1px solid #0030FF" : "1px solid  #00000042",
      backgroundColor: "#ffffff",
      marginRight: theme.spacing(2),
      borderRadius: "0 8px 8px 0"
    },
    radioContainer: {
      alignItems: "center",
      display: "flex"
    },
    styledFormControlLabel: {
      marginRight: "4px"
    },
    backdrop: {
      zIndex: 2000,
      color: "#fff"
    }
  }),
  { name: "UnlockCodesCard" }
);
